import { isValidPhoneNumber } from 'libphonenumber-js';

export { isValidPhoneNumber };

export const isPhoneNumber = (phone: string) => {
  const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]{7,15}$/;
  return phoneRegex.test(phone) && isValidPhoneNumber(phone);
};
